__turbopack_context__.v({
  "blocksBackgroundColor": "SearchPage-module-scss-module__JUQfCG__blocksBackgroundColor",
  "blocksContainer": "SearchPage-module-scss-module__JUQfCG__blocksContainer",
  "blocksFontColor": "SearchPage-module-scss-module__JUQfCG__blocksFontColor",
  "blocksFooter": "SearchPage-module-scss-module__JUQfCG__blocksFooter",
  "collapseBar": "SearchPage-module-scss-module__JUQfCG__collapseBar",
  "container": "SearchPage-module-scss-module__JUQfCG__container",
  "eyeglass": "SearchPage-module-scss-module__JUQfCG__eyeglass",
  "filterToggle": "SearchPage-module-scss-module__JUQfCG__filterToggle",
  "filtersBody": "SearchPage-module-scss-module__JUQfCG__filtersBody",
  "filtersContainer": "SearchPage-module-scss-module__JUQfCG__filtersContainer",
  "filtersContainerExpanded": "SearchPage-module-scss-module__JUQfCG__filtersContainerExpanded",
  "filtersList": "SearchPage-module-scss-module__JUQfCG__filtersList",
  "filtersListExpanded": "SearchPage-module-scss-module__JUQfCG__filtersListExpanded",
  "filtersListSearch": "SearchPage-module-scss-module__JUQfCG__filtersListSearch",
  "filtersListSearchExpanded": "SearchPage-module-scss-module__JUQfCG__filtersListSearchExpanded",
  "initialContainer": "SearchPage-module-scss-module__JUQfCG__initialContainer",
  "loadingContainer": "SearchPage-module-scss-module__JUQfCG__loadingContainer",
  "mobileSearchFilterGrabBar": "SearchPage-module-scss-module__JUQfCG__mobileSearchFilterGrabBar",
  "onPageSearchBox": "SearchPage-module-scss-module__JUQfCG__onPageSearchBox",
  "pageResultsContainer": "SearchPage-module-scss-module__JUQfCG__pageResultsContainer",
  "search": "SearchPage-module-scss-module__JUQfCG__search",
  "searchHeading": "SearchPage-module-scss-module__JUQfCG__searchHeading",
  "secondaryNavBackgroundColor": "SearchPage-module-scss-module__JUQfCG__secondaryNavBackgroundColor",
  "speech": "SearchPage-module-scss-module__JUQfCG__speech",
  "themeBackgroundColor": "SearchPage-module-scss-module__JUQfCG__themeBackgroundColor",
  "themeFontColor": "SearchPage-module-scss-module__JUQfCG__themeFontColor",
});
